<app-menu-superior [user]="user" [button]="true" [title]="'COMPRAS'"></app-menu-superior>

<ion-content fullscreen>

  <ion-grid class="ion-no-padding class-grid">
    <ion-row style="">
      <ion-col style="background-color: #7194a5; width:100%; " class="ion-no-padding verticalLeft">
        <mat-form-field (click)="picker.open()" style="width:100%;background-color: #7194a5;" 
          class="verticalLeft text-left">
          <mat-label style="margin-top: auto;">
            <span class="label-wrapper" style="font-size: 19px; color: white !important;">Seleccione una Fecha</span>
          </mat-label>
          <input style="color: #f8f9fa;width:100%;margin-bottom: auto;" matInput [matDatepicker]="picker" readonly
            (dateChange)="onBlur($event)" (keydown.enter)="picker.open()" [(ngModel)]="fecha" name="inputDatepicker">
          <mat-datepicker-toggle style="color: #f8f9fa; width:100%; transform: scale(1.5);" matSuffix
            [for]="picker"></mat-datepicker-toggle>

          <mat-datepicker style="color: #f8f9fa;" touchUi #picker></mat-datepicker>
        </mat-form-field>
      </ion-col>
    </ion-row>
    <ion-row style="height: 90%;">
      <ion-col class="container ion-no-padding noScrollBar">
        <table class="lista-pesadas custom-table my-table" multiTemplateDataRows mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
          <ng-container matColumnDef="fecha">
            <th mat-header-cell mat-sort-header="fecha" *matHeaderCellDef class="textHeader">FECHA </th>
            <td mat-cell *matCellDef="let element" class="textContent"> {{element.fecha}} </td>
            <td mat-footer-cell *matFooterCellDef class="filafooter">Total:</td>
          </ng-container>

          <ng-container matColumnDef="proveedor">
            <th mat-sort-header="proveedor" mat-header-cell *matHeaderCellDef class="table-header-cell textHeader">BARCO
            </th>
            <td mat-cell *matCellDef="let element" class="textContent text-left"> {{element.proveedor}}
            </td>
            <td mat-footer-cell *matFooterCellDef class="filafooter text-left">Total:</td>
          </ng-container>

          <ng-container matColumnDef="especie">
            <th mat-header-cell mat-sort-header="especie" *matHeaderCellDef class="table-header-cell textHeader">ESPECIE
            </th>
            <td mat-cell *matCellDef="let element" class="textContent text-left"> {{element.especie}}
            </td>

          </ng-container>

          <ng-container matColumnDef="cantidad">
            <th mat-header-cell mat-sort-header="cantidad" arrowPosition="before" *matHeaderCellDef
              class="table-header-cell textHeader">KG</th>
            <td mat-cell *matCellDef="let element" class="textContent">
              {{element.cantidadkm | number:'1.2-2':'es'}} </td>
            <td mat-footer-cell *matFooterCellDef class="filafooter textContent text-right" colspan="2">
              {{cantidadFinal | number:'1.2-2':'es'}} KG </td>
          </ng-container>

          <ng-container matColumnDef="precio">
            <th mat-header-cell mat-sort-header="precio" arrowPosition="before" *matHeaderCellDef
              class="table-header-cell textHeader text-right">€/KG</th>
            <td mat-cell *matCellDef="let element" class="textContent">
              {{element.precio | number:'1.2-2':'es'}} </td>
          </ng-container>

          <ng-container matColumnDef="importe">
            <th mat-header-cell mat-sort-header="importe" arrowPosition="before" *matHeaderCellDef
              class="table-header-cell textHeader text-right">€</th>
            <td mat-cell *matCellDef="let element" class="textContent">
              {{element.importe | number:'1.2-2':'es'}} </td>
            <td mat-footer-cell *matFooterCellDef class="filafooter textContent text-right" colspan="2">
              {{importeFinal | number:'1.2-2':'es'}} €</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row lineas" 
 (click)="user.roles?.includes('Cesion') ? openCesion(element):false"
          [ngClass]="{
            'verde': element.cesiones==element.cantidad,
            'azul': element.cesiones!=element.cantidad && element.cesiones!=0
          }">
          
          </tr>

          <tr mat-footer-row *matFooterRowDef="displayedFooterColumns ;sticky: true "></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="5">No hay ninguna compra para este día</td>
          </tr>
        </table>

      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
